import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/sections/HeroSection';
import AboutSection from '../components/sections/AboutSection';
import SkillsSection from '../components/sections/SkillsSection';
import ProjectsSection from '../components/sections/ProjectsSection';
import ContactSection from '../components/sections/ContactSection';
import Meta from '../components/ui/Meta';
import { Helmet } from 'react-helmet';

function HomePage() {
  const personSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "İbrahim Levent",
    "url": "https://ibrahimlevent.com.tr",
    "sameAs": [
      "https://tr.linkedin.com/in/ibrahimlevent",
      "https://github.com/ibrahimlevent"
    ],
    "jobTitle": "Full Stack Web Developer",
    "worksFor": {
      "@type": "Organization",
      "name": "Freelancer"
    },
    "image": "https://ibrahimlevent.com.tr/images/about/profile.png",
    "description": "Full Stack Web Developer. PHP, Laravel, React.js, Node.js ile profesyonel web çözümleri geliştiriyorum.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Ankara",
      "addressCountry": "TR"
    },
    "email": "mailto:hey@ibrahimlevent.com.tr"
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "url": "https://ibrahimlevent.com.tr/",
    "name": "İbrahim Levent - Portfolio",
    "author": {
      "@type": "Person",
      "name": "İbrahim Levent"
    },
    "description": "İbrahim Levent'in kişisel portfolyo web sitesi. Full Stack Web Developer olarak yaptığı projeleri ve yeteneklerini sergilemektedir.",
    "keywords": "İbrahim Levent, Full Stack Developer, Web Developer, PHP, Laravel, React, Node.js, Portfolio"
  };

  return (
    <div className="min-h-screen">
      <Meta
        title="İbrahim Levent - Full Stack Web Developer | Portfolio"
        description="İbrahim Levent, PHP, Laravel, React ve Node.js gibi modern teknolojilerle çalışan bir Full Stack Web Developer. Projelerimi ve yeteneklerimi keşfedin."
        keywords="İbrahim Levent, Full Stack Developer, Web Developer, PHP, Laravel, React, Node.js, Portfolio"
        canonicalUrl="https://ibrahimlevent.com.tr"
      />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(personSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      </Helmet>

      <Header />
      <HeroSection />
      <AboutSection />
      <SkillsSection />
      <ProjectsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default HomePage;
